import $ from 'jquery';
import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
//
const selectors = {
  list: '.js-testimonials-list',
  item: '.js-testimonial',
};

/**
 * Testimonials section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

register('testimonials', {
  onLoad() {

    this.$container = $(this.container);
    this.namespace = `.${this.id}`;

    this.$sliders = $(selectors.list, this.$container);
    if (this.$sliders.length > 0) {
      this.flick = new Flickity(this.$sliders[0], {
        pageDots: true,
        cellSelector: selectors.item, wrapAround: true,
        prevNextButtons: true,
        arrowShape: 'M29.41406,21.09375 L22.34375,28.16406 C22.109375,28.42448 21.81641,28.55469 21.464845,28.55469 C21.11328,28.55469 20.820315,28.42448 20.58594,28.16406 C20.32552,27.929685 20.19531,27.63672 20.19531,27.285155 C20.19531,26.93359 20.32552,26.640625 20.58594,26.40625 L25.74219,21.25 L12.5,21.25 C12.161455,21.25 11.86849,21.126305 11.621095,20.878905 C11.373695,20.63151 11.25,20.338545 11.25,20 C11.25,19.661455 11.373695,19.36849 11.621095,19.121095 C11.86849,18.873695 12.161455,18.75 12.5,18.75 L25.74219,18.75 L20.58594,13.59375 C20.32552,13.359375 20.19531,13.06641 20.19531,12.714845 C20.19531,12.36328 20.32552,12.070315 20.58594,11.83594 C20.820315,11.57552 21.11328,11.44531 21.464845,11.44531 C21.81641,11.44531 22.109375,11.57552 22.34375,11.83594 L29.41406,18.90625 C29.570315,19.0625 29.67448,19.23828 29.72656,19.433595 C29.778645,19.628905 29.778645,19.817705 29.72656,20 C29.778645,20.182295 29.778645,20.371095 29.72656,20.566405 C29.67448,20.76172 29.570315,20.9375 29.41406,21.09375 Z',
      });
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    if (this.flick) {
      this.flick.destroy();
    }
    this.$container.off(this.namespace);
  },
});
